import { createAction } from '@reduxjs/toolkit';

const ACTION_PREFIX = 'app';

export const fetchUseCases = createAction(`${ACTION_PREFIX}/USE_CASES_FETCH`);
export const fetchUseCasesSucceeded = createAction(`${ACTION_PREFIX}/USE_CASES_FETCH_SUCCEEDED`);
export const fetchUseCasesFailed = createAction(`${ACTION_PREFIX}/USE_CASES_FETCH_FAILED`);

export const setOnBoardingEmailConfirm = createAction(`${ACTION_PREFIX}/SET_ON_BOARDING_EMAIL_CONFIRM`);
export const setOnBoardingBlockReason = createAction(`${ACTION_PREFIX}/SET_ON_BOARDING_BLOCK_REASON`);

export const enableTeamManagement = createAction(`${ACTION_PREFIX}/ENABLE_TEAM_MANAGEMENT`);
export const enableTeamManagementSucceeded = createAction(`${ACTION_PREFIX}/ENABLE_TEAM_MANAGEMENT_SUCCEEDED`);
export const enableTeamManagementFailed = createAction(`${ACTION_PREFIX}/ENABLE_TEAM_MANAGEMENT_FAILED`);

export const disableTeamManagement = createAction(`${ACTION_PREFIX}/DISABLE_TEAM_MANAGEMENT`);
export const disableTeamManagementSucceeded = createAction(`${ACTION_PREFIX}/DISABLE_TEAM_MANAGEMENT_SUCCEEDED`);
export const disableTeamManagementFailed = createAction(`${ACTION_PREFIX}/DISABLE_TEAM_MANAGEMENT_FAILED`);

export const closedPasswordBanner = createAction(`${ACTION_PREFIX}/CLOSED_PASSWORD_BANNER`);
export const updateBannerState = createAction(`${ACTION_PREFIX}/UPDATE_BANNER_STATE`);

export const eventTracking = createAction(`${ACTION_PREFIX}/EVENT_TRACKING`);
export const eventTrackingSucceeded = createAction(`${ACTION_PREFIX}/EVENT_TRACKING_SUCCEEDED`);
export const eventTrackingFailed = createAction(`${ACTION_PREFIX}/EVENT_TRACKING_FAILED`);

export const AppActions = {
  setOnBoardingBlockReason,
  setOnBoardingEmailConfirm,

  fetchUseCases,
  fetchUseCasesSucceeded,
  fetchUseCasesFailed,

  enableTeamManagement,
  enableTeamManagementSucceeded,
  enableTeamManagementFailed,

  disableTeamManagement,
  disableTeamManagementSucceeded,
  disableTeamManagementFailed,

  eventTracking,
  eventTrackingSucceeded,
  eventTrackingFailed,

  closedPasswordBanner,
  updateBannerState,
};
